import { UMIcon, UMR } from '../_components';
import type { SelectionTool } from './types';

export const BUILDING_TOOLS: { id: SelectionTool; icon: string; label: string; danger?: boolean }[] = [
  { id: 'add-one', icon: 'domain_add', label: 'Ajouter un bâtiment' },
  { id: 'add-zone', icon: 'highlight_alt', label: 'Ajouter des bâtiments par zone' },
  { id: 'remove-one', icon: 'domain_disabled', label: 'Retirer un bâtiment', danger: true },
  { id: 'remove-zone', icon: 'remove_selection', label: 'Retirer des bâtiments par zone', danger: true },
];

const DANGER = 'var(--nj-core-color-red-600, #d9261c)';

/** Colonne verticale collée au bord droit du panneau de gauche, visible tant qu'une sélection est active. */
export function SelectionToolRail({ activeTool, pendingCount = 0, blocked = false, onToolChange, top = UMR.size.toolbarHeight + 16 }: {
  activeTool: SelectionTool | null; pendingCount?: number; blocked?: boolean; top?: number; onToolChange: (id: SelectionTool) => void;
}) {
  return (
    <div role="group" aria-label="Actions sur les bâtiments" style={{
      position: 'absolute', top, left: 0, zIndex: 31,
      display: 'flex', flexDirection: 'column', background: UMR.white,
      border: `1px solid ${UMR.border}`, borderLeft: 'none', boxShadow: '0 1px 4px rgba(0,0,0,0.12)',
    }}>
      <style>{`
        .selection-building-tool { background: transparent; }
        .selection-building-tool:hover:not(:disabled), .selection-building-tool[aria-pressed="true"] { background: ${UMR.hover}; }
        .selection-building-tool:disabled { opacity: 0.5; cursor: not-allowed; }
      `}</style>
      {BUILDING_TOOLS.map(({ id, icon, label, danger }) => (
        <button key={id} type="button" className="selection-building-tool"
          aria-label={label} title={label} aria-pressed={activeTool === id}
          disabled={blocked || (!!activeTool && activeTool !== id)}
          onClick={() => onToolChange(id)}
          style={{
            width: UMR.size.iconButton, height: UMR.size.iconButton, display: 'flex', alignItems: 'center', justifyContent: 'center',
            border: 'none', padding: 0, background: activeTool === id ? UMR.active : undefined,
            color: danger ? DANGER : UMR.blue, cursor: 'pointer', position: 'relative',
          }}>
          <UMIcon name={icon} size={20} color={danger ? DANGER : UMR.blue} />
          {activeTool === id && pendingCount > 0 && (
              <span aria-label={`${pendingCount} bâtiment(s) en attente`} style={{
                position: 'absolute', top: 2, right: 2, minWidth: 16, height: 16, padding: '0 4px', boxSizing: 'border-box',
                borderRadius: 8, background: (danger ? DANGER : UMR.blue), color: UMR.white, fontSize: 11, fontWeight: 700, lineHeight: '16px', textAlign: 'center',
              }}>{pendingCount}</span>
            )}
        </button>
      ))}
    </div>
  );
}
